<template>
  <ElButton
    icon="el-icon-delete"
    type="danger"
    size="small"
    plain
    v-bind="$attrs"
    :loading="loading"
    class="deactivate-release-button"
    @click="confirmDeactivateRelease"
  >
    {{ $t('APP.RELEASES.DEACTIVATE_RELEASE') }}
  </ElButton>
</template>

<script>
import packageName from '@/mixins/packageName';
import Release from '@/api/app-releases';
import { mapActions } from 'vuex';
import { RELEASES } from '@/store/types';

export default {
  name: 'DeactivateReleaseButton',
  mixins: [packageName],
  props: {
    releaseId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      fetchReleases: RELEASES,
    }),
    confirmDeactivateRelease() {
      return this.$confirm(
        this.$t('APP.RELEASES.DEACTIVE_WARNING'),
        this.$t('WARNING'),
        {
          confirmButtonText: this.$t('DEACTIVATE'),
          cancelButtonText: this.$t('CANCEL'),
          confirmButtonClass:
            'deactivate-release-button__delete-confirm-button',
          type: 'error',
        },
      )
        .then(() => {
          this.deactivateRelease();
        })
        .catch(() => {});
    },
    deactivateRelease() {
      this.loading = true;
      return Release.deactivateRelease({
        releaseId: this.releaseId,
        packageName: this.packageName,
      })
        .then(({ message }) => {
          if (message) {
            this.$message.success(message);
          }
          return this.fetchReleases(this.packageName).then(() => {
            this.loading = false;
          });
        })
        .catch(({ message }) => {
          this.loading = false;
          if (message) {
            this.$message.error(message);
          }
        });
    },
  },
};
</script>
<style lang="scss">
.deactivate-release-button {
  margin-left: $global-margin;
  @include rtl() {
    margin-left: 0;
    margin-right: $global-margin;
  }

  @include breakpoint(medium down) {
    /* stylelint-disable-next-line */
    & > span {
      display: none;
    }
  }

  &__delete-confirm-button {
    background-color: $alizarin;
    border: 0;

    &:hover,
    &:focus {
      background-color: $alizarin;
    }
  }
}
</style>
